module.exports = __webpack_public_path__ + "static/media/navigation-dots-vertical.0ca4bf89.svg";